export default "__VITE_ASSET__BWcJThDT__"